import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IServiceRequestResponse,
  IServiceRequestState,
  IRequestItem,
  IPrice,
} from "../@types/requests";

const initialState: IServiceRequestState = {
  data: [],
  request: null,
  current_page: 1,
  last_page: 1,
  per_page: 20,
  total: 0,
  loading: false,
  priceLoading: false,
};

export const serviceRequest = createSlice({
  name: "service-request",
  initialState,
  reducers: {
    setServiceRequests: (
      state,
      action: PayloadAction<IServiceRequestResponse>,
    ) => {
      const payload = action.payload.data;

      state.data = payload.data;
      state.current_page = payload.current_page;
      state.last_page = payload.last_page;
      state.per_page = payload.per_page;
      state.total = payload.total;
    },

    setServiceRequest: (state, action: PayloadAction<IRequestItem | null>) => {
      state.request = action.payload;
    },

    createRequestPrice: (state, action: PayloadAction<IPrice>) => {
      if (!state.request) return;

      const existingPrices = state.request.price ?? [];
      state.request.price = [action.payload, ...existingPrices];
    },
    updateRequestPrice: (state, action: PayloadAction<IPrice>) => {
      if (!state.request) return;

      state.request.price = (state.request.price ?? []).map((priceItem) =>
        priceItem.id === action.payload.id
          ? { ...priceItem, ...action.payload }
          : priceItem,
      );
    },

    onNext: (state) => {
      state.current_page = state.current_page + 1;
    },

    onBack: (state) => {
      state.current_page = state.current_page - 1;
    },

    setLoadingTrue: (state) => {
      state.loading = true;
    },

    setLoadingFalse: (state) => {
      state.loading = false;
    },

    setPriceLoadingTrue: (state) => {
      state.priceLoading = true;
    },

    setPriceLoadingFalse: (state) => {
      state.priceLoading = false;
    },
  },
});

export const {
  setServiceRequests,
  setServiceRequest,
  createRequestPrice,
  updateRequestPrice,
  onNext,
  onBack,
  setLoadingTrue,
  setLoadingFalse,
  setPriceLoadingTrue,
  setPriceLoadingFalse,
} = serviceRequest.actions;

export default serviceRequest.reducer;
